import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/web.dom-collections.for-each.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { fetchCheckList, fetchDetail, fetchFileList } from '@/api/PMS/houseDeliveryManage/decorationRegistration';
export default {
  props: {
    showDialog: Boolean,
    keyValue: {
      type: Number,
      default: -1
    }
  },
  data: function data() {
    return {
      uploadUrl: '',
      dialogImageUrl: '',
      downloadUrl: '',
      loading: false,
      dialogVisible: false,
      listObj: {},
      fileList: [],
      addList: [],
      removeList: [],
      oldImgList: [],
      customerList: [],
      list: [],
      multipleSelection: [],
      childData: {},
      dates: [],
      files: [],
      options: []
    };
  },
  watch: {
    showDialog: function showDialog(n, o) {
      if (n) {
        this.$refs.dataForm.resetFields();
        this.init();
      }
    }
  },
  created: function created() {
    this.uploadUrl = process.env.VUE_APP_UPLOAD;
    this.downloadUrl = process.env.VUE_APP_DOWNLOAD;
    this.init();
  },
  methods: {
    init: function init() {
      var _this = this;

      this.customerList = [];
      this.$nextTick(function () {
        _this.$refs['dataForm'].clearValidate();
      });

      if (this.keyValue > 0) {
        var queryData = {
          id: this.keyValue
        };
        fetchDetail(queryData).then(function (response) {
          if (response.data.code === 200) {
            _this.childData = response.data.data;

            _this.dates.push(_this.childData.beginDate);

            _this.dates.push(_this.childData.expectEndDate);
          }
        });
        fetchFileList(queryData).then(function (res) {
          if (res.data.code === 200 && res.data.data) {
            _this.files = res.data.data;

            _this.files.forEach(function (item) {
              item.name = item.fileName;
              item.url = item.filePath;
            });
          }
        });
        fetchCheckList(queryData).then(function (response) {
          _this.list = response.data.data;
        });
      } else {
        this.childData = {};
      }
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    handleSuccess: function handleSuccess(response, file) {
      var _this2 = this;

      var imgUrl = this.downloadUrl + response.data[0].fileId;
      this.addList.push({
        url: imgUrl
      });
      var uid = file.uid;
      var objKeyArr = Object.keys(this.listObj);

      for (var i = 0, len = objKeyArr.length; i < len; i++) {
        if (this.listObj[objKeyArr[i]].name === uid) {
          this.listObj[objKeyArr[i]].url = response.data[0].fileId;
        }
      }

      this.uploadList = Object.keys(this.listObj).map(function (item) {
        return _this2.listObj[item];
      });
    },
    beforeUpload: function beforeUpload(file) {
      var _this3 = this;

      var fileName = file.uid;
      this.listObj[fileName] = {};
      return new Promise(function (resolve, reject) {
        _this3.listObj[fileName] = {
          name: file.uid
        };
        resolve(true);
      });
    },
    handleRemove: function handleRemove(file) {
      var _this4 = this;

      var uid = file.uid;
      var objKeyArr = Object.keys(this.listObj);

      for (var i = 0, len = objKeyArr.length; i < len; i++) {
        if (this.listObj[objKeyArr[i]].name === uid) {
          delete this.listObj[objKeyArr[i]];
        }
      }

      this.oldImgList.forEach(function (item) {
        if (item.url === file.url) {
          var fileId = item.url.split('fileId=')[1];

          _this4.removeList.push({
            url: fileId
          });
        }

        _this4.addList.forEach(function (item, index) {
          if (item.url === file.url) {
            _this4.addList.splice(index, 1);
          }
        });
      });
    },
    handlePreview: function handlePreview(file) {
      if (file.response !== undefined) {
        // 当还未保存到业务逻辑中时的预览图片
        if (file.raw.type === 'image/png' || file.raw.type === 'image/jpeg' || file.raw.type === 'image/jpg') {
          // 当附件是图片的时候在线打开
          this.dialogVisible = true;
          this.dialogImageUrl = this.downloadUrl + file.response.data[0].fileId;
        } else {
          // 当附件是文件的时候在线下载
          this.dialogImageUrl = this.downloadUrl + file.response.data[0].fileId;
          this.handleDownload(this.dialogImageUrl, file.name);
        }
      } else {
        // 当已保存到业务逻辑中时的预览图片
        if (file.fileType === 2) {
          // 当附件是图片的时候在线打开
          this.dialogVisible = true;
          this.dialogImageUrl = this.downloadUrl + file.url;
        } else {
          // 当附件是文件的时候在线下载
          this.dialogImageUrl = this.downloadUrl + file.url;
          this.handleDownload(this.dialogImageUrl, file.name);
        }
      }
    },
    // 下载文件
    handleDownload: function handleDownload(url, name) {
      var link = document.createElement('a');
      link.style.display = 'none';
      link.href = url;
      link.setAttribute('download', name);
      document.body.appendChild(link);
      link.click();
    }
  }
};